import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/map/types";

const getRecipientDisplayName = (recipient: EntitiesSupportedByEmailFeature): string =>
  `${recipient.name} <${recipient.email}>`;

export default getRecipientDisplayName;
